import React from 'react'
import Slider from 'react-slick'

import Card from '../Card/Article'
import More from '../MoreCTA'

const settings = {
    dots: true,
    infinite: false,
    arrows: false,
    settings: "unslick",
    responsive: [
        {
            breakpoint: 999999,
            settings: "unslick"
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
}

const renderArticleCards = cards => cards.map(item => {
    return (
        <div key={cards.indexOf(item)} className="col-4_xs-12">
            <Card {...item} />
        </div>
    )
})

const ArticleCardList = ({cards}) => {
    return (
        <div className="container">
            <Slider {...settings} className="grid">
                { renderArticleCards(cards) }
            </Slider>

            <div className="more-container" style={{textAlign: 'center', marginTop: '60px', marginBottom: '70px'}}>
                <More text="Mais artigos" url='/artigos' />
            </div>
        </div>
    );
};

export default ArticleCardList;


// WEBPACK FOOTER //
// ./src/components/ArticleCardList/index.js